import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Layout from '../components/layout';
import SEO from '../components/seo';

const Container = styled.div`
	max-width: 767px;
	margin: 0 auto;
	padding: 3em 1em;
`;
const Heading = styled.h1`
	font-size: calc(1.35vw + 1.35em);
	margin-bottom: 0.25em;
`;
const Subheading = styled.h2`
	font-size: calc(0.75vw + 1em);
`;
const p = styled.p``;

const PrivacyPolicy = props => (
	<StaticQuery
		query={graphql`
			query WebsiteInfoForScholarship {
				site {
					siteMetadata {
						title
						siteUrl
						description
						companyInfo {
							phone
							email
							addressLine1
							addressLine2
							city
							state
							zip
							license
						}
					}
				}
			}
		`}
		render={data => (
			<>
				<Layout pageProps={props}>
					<SEO
						title={'Privacy Policy | Bay Area Siding Company'}
						description={
							'Bay Area Siding Company Privacy Policy - This policy covers how we collect, use, and store your personal information.'
						}
					/>
					<div className="max-w-7xl mx-auto px-6">
						<div className="prose max-w-7xl mx-auto px-6 py-12">
  <h2>Our Commitment to Privacy</h2>
  <p>Effective Date: May 28, 2025</p>
  <p>
    Your privacy matters to us. This Privacy Policy explains how Bay Area Siding Company (“Company,” “we,” “our”) collects, uses, shares, and safeguards your personal information when you visit {data.site.siteMetadata.siteUrl}. This policy complies with the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA).
  </p>

  <hr />

  <Subheading>1. Information We Collect</Subheading>
  <p>We may collect the following categories of personal data:</p>
  <ul>
    <li>Identifiers: name, email, phone number, mailing address, IP address</li>
    <li>Commercial information: project interests, services requested</li>
    <li>Internet activity: pages viewed, device type, location (approximate)</li>
    <li>Professional information (if submitted)</li>
    <li>Inferences drawn from your use of our website</li>
  </ul>
  <p>Data may be collected directly (forms, emails) or automatically (cookies, analytics tools).</p>

  <Subheading>2. How We Use Your Information</Subheading>
  <ul>
    <li>Respond to inquiries and service requests</li>
    <li>Improve website experience and marketing performance</li>
    <li>Send updates, promotions, or policy notices (you may opt out of marketing)</li>
    <li>Comply with legal obligations</li>
  </ul>

  <Subheading>3. Cookies and Tracking</Subheading>
  <p>
    We use cookies and similar technologies to personalize your experience and understand how visitors interact with our website. You may manage cookies via your browser settings.
  </p>

  <Subheading>4. Sharing of Information</Subheading>
  <p>
    We do not sell your personal data. We may share it with trusted service providers (e.g., analytics, CRM) or to comply with legal requirements. Any sharing is subject to contractual safeguards.
  </p>

  <Subheading>5. Your California Privacy Rights</Subheading>
  <p>As a California resident, you have the right to:</p>
  <ul>
    <li>Request access to your data</li>
    <li>Request correction or deletion of personal data</li>
    <li>Opt out of the sale or sharing of your data</li>
    <li>Not be discriminated against for exercising your privacy rights</li>
  </ul>
  <p>To exercise any of these rights, contact us at {data.site.siteMetadata.companyInfo.phone} or via email.</p>

  <Subheading>6. How to Opt Out</Subheading>
  <p>
    While we do not sell your data, you may email us with the subject line “Do Not Sell or Share My Personal Information” if you'd like to limit certain types of data sharing with third parties.
  </p>

  <Subheading>7. Data Security</Subheading>
  <p>
    We protect your data using secure servers, encryption, and limited employee access. No system is completely secure, but we take reasonable steps to protect your personal information both online and offline.
  </p>

  <Subheading>8. Children's Privacy</Subheading>
  <p>
    This site is not intended for children under 16. We do not knowingly collect personal information from minors.
  </p>

  <Subheading>9. Policy Updates</Subheading>
  <p>
    We may revise this policy from time to time. Updates will be posted on this page with an updated effective date.
  </p>

  
</div>
					</div>
				</Layout>
			</>
		)}
	/>
);

export default PrivacyPolicy;
